// Core
import React from "react";

// Styles
import "./style.scss";

// Custom components
import NumberStepper from "Components/NumberStepper";

const SubModule = ({
  subModule,
  index,
  totalSteps,
  onclick,
  currentSubCategoryIndex,
  displayNumber,
}) => {
  const getStatusLabelClass = () => {
    if(subModule?.subCategory_name === "Additional insights" || subModule?.subCategory_name === "Feedback") {
      return "label-pending"
    }

    if (subModule?.isCompleted) {
      return "label-completed";
    } else if (index === currentSubCategoryIndex) {
      return "label-inprogress";
    } else {
      return "label-pending";
    }
  };

  const getStatus = (data, index) => {
    if(data?.subCategory_name === "Additional insights" || data?.subCategory_name === "Feedback") {
      return "No input needed from Assessor"
    }
    const hasAnswer = data?.questions?.some(q => q?.isAnyAnswerPresent);
    const isScorable = data?.questions?.[0]?.is_scorable;

    if (hasAnswer && isScorable) {
      return data?.isCompleted
        ? "Completed"
        : index === currentSubCategoryIndex
          ? "In progress"
          : "Pending";
    }

    if (hasAnswer && !isScorable) {
      return "No input needed from Assessor";
    }

    return "No user input";
  };




  return (
    <div className="subModule">
      <div className="stepper">
        {/* Use Stepper Component */}
        <NumberStepper
          index={index}
          status={subModule?.isCompleted}
          totalSteps={totalSteps}
          currentSubCategoryIndex={currentSubCategoryIndex}
          hideNumber={
            subModule?.subCategory_name === "Feedback" ||
            subModule?.subCategory_name === "Additional insights"
          }
          displayNumber={displayNumber}
        />

        {/* Step Details */}
        <div className="step-details">
          <div style={{ cursor: "pointer", color: subModule?.questions?.[0]?.isApproverFeedback ? "red" : "inherit" }} onClick={onclick} className="subModTitle">{subModule.subCategory_name}</div>
          <div className={`subModStatus ${getStatusLabelClass()}`}>
            {/* {subModule.isCompleted
              ? "Completed"
              : index === currentSubCategoryIndex
                ? "In Progress"
                :  !subModule?.is_scorable ? "Not Required" : "Pending" } */}
            {getStatus(subModule, index)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubModule;
